import createPersistedState from 'vuex-persistedstate'

export default ({ store }) => {
  createPersistedState({
    paths: [
      'devise','auth',
    ],  // localStorageに保存したいstoreを入れる
  })(store);
};